import { render, staticRenderFns } from "./cause-info.vue?vue&type=template&id=50415594&scoped=true&"
import script from "./cause-info.vue?vue&type=script&lang=js&"
export * from "./cause-info.vue?vue&type=script&lang=js&"
import style0 from "./cause-info.vue?vue&type=style&index=0&id=50415594&scoped=true&lang=css&"
import style1 from "./cause-info.vue?vue&type=style&index=1&id=50415594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50415594",
  null
  
)

export default component.exports